/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UpdatePasswordRouteImport } from './routes/update-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedInvitesRouteImport } from './routes/_authenticated/invites'
import { Route as AuthenticatedAdminRouteRouteImport } from './routes/_authenticated/admin/route'
import { Route as AuthenticatedTenantIdRouteRouteImport } from './routes/_authenticated/$tenantId/route'
import { Route as AuthenticatedOnboardIndexRouteImport } from './routes/_authenticated/onboard/index'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedTenantIdIndexRouteImport } from './routes/_authenticated/$tenantId/index'
import { Route as AuthenticatedOnboardSetupSuppliersRouteImport } from './routes/_authenticated/onboard/setup-suppliers'
import { Route as AuthenticatedAdminOrganisationsRouteImport } from './routes/_authenticated/admin/organisations'
import { Route as AuthenticatedAdminSuppliersRouteRouteImport } from './routes/_authenticated/admin/suppliers/route'
import { Route as AuthenticatedTenantIdSettingsRouteRouteImport } from './routes/_authenticated/$tenantId/settings/route'
import { Route as AuthenticatedAdminSuppliersIndexRouteImport } from './routes/_authenticated/admin/suppliers/index'
import { Route as AuthenticatedTenantIdSettingsIndexRouteImport } from './routes/_authenticated/$tenantId/settings/index'
import { Route as AuthenticatedTenantIdRecipesIndexRouteImport } from './routes/_authenticated/$tenantId/recipes/index'
import { Route as AuthenticatedTenantIdIngredientsIndexRouteImport } from './routes/_authenticated/$tenantId/ingredients/index'
import { Route as AuthenticatedTenantIdSettingsTeamRouteImport } from './routes/_authenticated/$tenantId/settings/team'
import { Route as AuthenticatedTenantIdSettingsTaxRouteImport } from './routes/_authenticated/$tenantId/settings/tax'
import { Route as AuthenticatedTenantIdSettingsSuppliersRouteImport } from './routes/_authenticated/$tenantId/settings/suppliers'
import { Route as AuthenticatedTenantIdSettingsRecipeTagsRouteImport } from './routes/_authenticated/$tenantId/settings/recipe-tags'
import { Route as AuthenticatedTenantIdSettingsLabelsRouteImport } from './routes/_authenticated/$tenantId/settings/labels'
import { Route as AuthenticatedTenantIdSettingsBillingRouteImport } from './routes/_authenticated/$tenantId/settings/billing'
import { Route as AuthenticatedTenantIdRecipesRecipeIdRouteImport } from './routes/_authenticated/$tenantId/recipes/$recipeId'
import { Route as AuthenticatedTenantIdIngredientsIngredientIdRouteImport } from './routes/_authenticated/$tenantId/ingredients/$ingredientId'
import { Route as AuthenticatedAdminSuppliersSupplierIdIndexRouteImport } from './routes/_authenticated/admin/suppliers/$supplierId/index'
import { Route as AuthenticatedAdminSuppliersSupplierIdIngredientIdRouteImport } from './routes/_authenticated/admin/suppliers/$supplierId/$ingredientId'

const UpdatePasswordRoute = UpdatePasswordRouteImport.update({
  id: '/update-password',
  path: '/update-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedInvitesRoute = AuthenticatedInvitesRouteImport.update({
  id: '/invites',
  path: '/invites',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTenantIdRouteRoute =
  AuthenticatedTenantIdRouteRouteImport.update({
    id: '/$tenantId',
    path: '/$tenantId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOnboardIndexRoute =
  AuthenticatedOnboardIndexRouteImport.update({
    id: '/onboard/',
    path: '/onboard/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedTenantIdIndexRoute =
  AuthenticatedTenantIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantIdRouteRoute,
  } as any)
const AuthenticatedOnboardSetupSuppliersRoute =
  AuthenticatedOnboardSetupSuppliersRouteImport.update({
    id: '/onboard/setup-suppliers',
    path: '/onboard/setup-suppliers',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminOrganisationsRoute =
  AuthenticatedAdminOrganisationsRouteImport.update({
    id: '/organisations',
    path: '/organisations',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminSuppliersRouteRoute =
  AuthenticatedAdminSuppliersRouteRouteImport.update({
    id: '/suppliers',
    path: '/suppliers',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedTenantIdSettingsRouteRoute =
  AuthenticatedTenantIdSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedTenantIdRouteRoute,
  } as any)
const AuthenticatedAdminSuppliersIndexRoute =
  AuthenticatedAdminSuppliersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAdminSuppliersRouteRoute,
  } as any)
const AuthenticatedTenantIdSettingsIndexRoute =
  AuthenticatedTenantIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantIdSettingsRouteRoute,
  } as any)
const AuthenticatedTenantIdRecipesIndexRoute =
  AuthenticatedTenantIdRecipesIndexRouteImport.update({
    id: '/recipes/',
    path: '/recipes/',
    getParentRoute: () => AuthenticatedTenantIdRouteRoute,
  } as any)
const AuthenticatedTenantIdIngredientsIndexRoute =
  AuthenticatedTenantIdIngredientsIndexRouteImport.update({
    id: '/ingredients/',
    path: '/ingredients/',
    getParentRoute: () => AuthenticatedTenantIdRouteRoute,
  } as any)
const AuthenticatedTenantIdSettingsTeamRoute =
  AuthenticatedTenantIdSettingsTeamRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => AuthenticatedTenantIdSettingsRouteRoute,
  } as any)
const AuthenticatedTenantIdSettingsTaxRoute =
  AuthenticatedTenantIdSettingsTaxRouteImport.update({
    id: '/tax',
    path: '/tax',
    getParentRoute: () => AuthenticatedTenantIdSettingsRouteRoute,
  } as any)
const AuthenticatedTenantIdSettingsSuppliersRoute =
  AuthenticatedTenantIdSettingsSuppliersRouteImport.update({
    id: '/suppliers',
    path: '/suppliers',
    getParentRoute: () => AuthenticatedTenantIdSettingsRouteRoute,
  } as any)
const AuthenticatedTenantIdSettingsRecipeTagsRoute =
  AuthenticatedTenantIdSettingsRecipeTagsRouteImport.update({
    id: '/recipe-tags',
    path: '/recipe-tags',
    getParentRoute: () => AuthenticatedTenantIdSettingsRouteRoute,
  } as any)
const AuthenticatedTenantIdSettingsLabelsRoute =
  AuthenticatedTenantIdSettingsLabelsRouteImport.update({
    id: '/labels',
    path: '/labels',
    getParentRoute: () => AuthenticatedTenantIdSettingsRouteRoute,
  } as any)
const AuthenticatedTenantIdSettingsBillingRoute =
  AuthenticatedTenantIdSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedTenantIdSettingsRouteRoute,
  } as any)
const AuthenticatedTenantIdRecipesRecipeIdRoute =
  AuthenticatedTenantIdRecipesRecipeIdRouteImport.update({
    id: '/recipes/$recipeId',
    path: '/recipes/$recipeId',
    getParentRoute: () => AuthenticatedTenantIdRouteRoute,
  } as any)
const AuthenticatedTenantIdIngredientsIngredientIdRoute =
  AuthenticatedTenantIdIngredientsIngredientIdRouteImport.update({
    id: '/ingredients/$ingredientId',
    path: '/ingredients/$ingredientId',
    getParentRoute: () => AuthenticatedTenantIdRouteRoute,
  } as any)
const AuthenticatedAdminSuppliersSupplierIdIndexRoute =
  AuthenticatedAdminSuppliersSupplierIdIndexRouteImport.update({
    id: '/$supplierId/',
    path: '/$supplierId/',
    getParentRoute: () => AuthenticatedAdminSuppliersRouteRoute,
  } as any)
const AuthenticatedAdminSuppliersSupplierIdIngredientIdRoute =
  AuthenticatedAdminSuppliersSupplierIdIngredientIdRouteImport.update({
    id: '/$supplierId/$ingredientId',
    path: '/$supplierId/$ingredientId',
    getParentRoute: () => AuthenticatedAdminSuppliersRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/update-password': typeof UpdatePasswordRoute
  '/$tenantId': typeof AuthenticatedTenantIdRouteRouteWithChildren
  '/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/invites': typeof AuthenticatedInvitesRoute
  '/': typeof AuthenticatedIndexRoute
  '/$tenantId/settings': typeof AuthenticatedTenantIdSettingsRouteRouteWithChildren
  '/admin/suppliers': typeof AuthenticatedAdminSuppliersRouteRouteWithChildren
  '/admin/organisations': typeof AuthenticatedAdminOrganisationsRoute
  '/onboard/setup-suppliers': typeof AuthenticatedOnboardSetupSuppliersRoute
  '/$tenantId/': typeof AuthenticatedTenantIdIndexRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/onboard': typeof AuthenticatedOnboardIndexRoute
  '/$tenantId/ingredients/$ingredientId': typeof AuthenticatedTenantIdIngredientsIngredientIdRoute
  '/$tenantId/recipes/$recipeId': typeof AuthenticatedTenantIdRecipesRecipeIdRoute
  '/$tenantId/settings/billing': typeof AuthenticatedTenantIdSettingsBillingRoute
  '/$tenantId/settings/labels': typeof AuthenticatedTenantIdSettingsLabelsRoute
  '/$tenantId/settings/recipe-tags': typeof AuthenticatedTenantIdSettingsRecipeTagsRoute
  '/$tenantId/settings/suppliers': typeof AuthenticatedTenantIdSettingsSuppliersRoute
  '/$tenantId/settings/tax': typeof AuthenticatedTenantIdSettingsTaxRoute
  '/$tenantId/settings/team': typeof AuthenticatedTenantIdSettingsTeamRoute
  '/$tenantId/ingredients': typeof AuthenticatedTenantIdIngredientsIndexRoute
  '/$tenantId/recipes': typeof AuthenticatedTenantIdRecipesIndexRoute
  '/$tenantId/settings/': typeof AuthenticatedTenantIdSettingsIndexRoute
  '/admin/suppliers/': typeof AuthenticatedAdminSuppliersIndexRoute
  '/admin/suppliers/$supplierId/$ingredientId': typeof AuthenticatedAdminSuppliersSupplierIdIngredientIdRoute
  '/admin/suppliers/$supplierId': typeof AuthenticatedAdminSuppliersSupplierIdIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/update-password': typeof UpdatePasswordRoute
  '/invites': typeof AuthenticatedInvitesRoute
  '/': typeof AuthenticatedIndexRoute
  '/admin/organisations': typeof AuthenticatedAdminOrganisationsRoute
  '/onboard/setup-suppliers': typeof AuthenticatedOnboardSetupSuppliersRoute
  '/$tenantId': typeof AuthenticatedTenantIdIndexRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/onboard': typeof AuthenticatedOnboardIndexRoute
  '/$tenantId/ingredients/$ingredientId': typeof AuthenticatedTenantIdIngredientsIngredientIdRoute
  '/$tenantId/recipes/$recipeId': typeof AuthenticatedTenantIdRecipesRecipeIdRoute
  '/$tenantId/settings/billing': typeof AuthenticatedTenantIdSettingsBillingRoute
  '/$tenantId/settings/labels': typeof AuthenticatedTenantIdSettingsLabelsRoute
  '/$tenantId/settings/recipe-tags': typeof AuthenticatedTenantIdSettingsRecipeTagsRoute
  '/$tenantId/settings/suppliers': typeof AuthenticatedTenantIdSettingsSuppliersRoute
  '/$tenantId/settings/tax': typeof AuthenticatedTenantIdSettingsTaxRoute
  '/$tenantId/settings/team': typeof AuthenticatedTenantIdSettingsTeamRoute
  '/$tenantId/ingredients': typeof AuthenticatedTenantIdIngredientsIndexRoute
  '/$tenantId/recipes': typeof AuthenticatedTenantIdRecipesIndexRoute
  '/$tenantId/settings': typeof AuthenticatedTenantIdSettingsIndexRoute
  '/admin/suppliers': typeof AuthenticatedAdminSuppliersIndexRoute
  '/admin/suppliers/$supplierId/$ingredientId': typeof AuthenticatedAdminSuppliersSupplierIdIngredientIdRoute
  '/admin/suppliers/$supplierId': typeof AuthenticatedAdminSuppliersSupplierIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/update-password': typeof UpdatePasswordRoute
  '/_authenticated/$tenantId': typeof AuthenticatedTenantIdRouteRouteWithChildren
  '/_authenticated/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/_authenticated/invites': typeof AuthenticatedInvitesRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/$tenantId/settings': typeof AuthenticatedTenantIdSettingsRouteRouteWithChildren
  '/_authenticated/admin/suppliers': typeof AuthenticatedAdminSuppliersRouteRouteWithChildren
  '/_authenticated/admin/organisations': typeof AuthenticatedAdminOrganisationsRoute
  '/_authenticated/onboard/setup-suppliers': typeof AuthenticatedOnboardSetupSuppliersRoute
  '/_authenticated/$tenantId/': typeof AuthenticatedTenantIdIndexRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/onboard/': typeof AuthenticatedOnboardIndexRoute
  '/_authenticated/$tenantId/ingredients/$ingredientId': typeof AuthenticatedTenantIdIngredientsIngredientIdRoute
  '/_authenticated/$tenantId/recipes/$recipeId': typeof AuthenticatedTenantIdRecipesRecipeIdRoute
  '/_authenticated/$tenantId/settings/billing': typeof AuthenticatedTenantIdSettingsBillingRoute
  '/_authenticated/$tenantId/settings/labels': typeof AuthenticatedTenantIdSettingsLabelsRoute
  '/_authenticated/$tenantId/settings/recipe-tags': typeof AuthenticatedTenantIdSettingsRecipeTagsRoute
  '/_authenticated/$tenantId/settings/suppliers': typeof AuthenticatedTenantIdSettingsSuppliersRoute
  '/_authenticated/$tenantId/settings/tax': typeof AuthenticatedTenantIdSettingsTaxRoute
  '/_authenticated/$tenantId/settings/team': typeof AuthenticatedTenantIdSettingsTeamRoute
  '/_authenticated/$tenantId/ingredients/': typeof AuthenticatedTenantIdIngredientsIndexRoute
  '/_authenticated/$tenantId/recipes/': typeof AuthenticatedTenantIdRecipesIndexRoute
  '/_authenticated/$tenantId/settings/': typeof AuthenticatedTenantIdSettingsIndexRoute
  '/_authenticated/admin/suppliers/': typeof AuthenticatedAdminSuppliersIndexRoute
  '/_authenticated/admin/suppliers/$supplierId/$ingredientId': typeof AuthenticatedAdminSuppliersSupplierIdIngredientIdRoute
  '/_authenticated/admin/suppliers/$supplierId/': typeof AuthenticatedAdminSuppliersSupplierIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/update-password'
    | '/$tenantId'
    | '/admin'
    | '/invites'
    | '/'
    | '/$tenantId/settings'
    | '/admin/suppliers'
    | '/admin/organisations'
    | '/onboard/setup-suppliers'
    | '/$tenantId/'
    | '/admin/'
    | '/onboard'
    | '/$tenantId/ingredients/$ingredientId'
    | '/$tenantId/recipes/$recipeId'
    | '/$tenantId/settings/billing'
    | '/$tenantId/settings/labels'
    | '/$tenantId/settings/recipe-tags'
    | '/$tenantId/settings/suppliers'
    | '/$tenantId/settings/tax'
    | '/$tenantId/settings/team'
    | '/$tenantId/ingredients'
    | '/$tenantId/recipes'
    | '/$tenantId/settings/'
    | '/admin/suppliers/'
    | '/admin/suppliers/$supplierId/$ingredientId'
    | '/admin/suppliers/$supplierId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/update-password'
    | '/invites'
    | '/'
    | '/admin/organisations'
    | '/onboard/setup-suppliers'
    | '/$tenantId'
    | '/admin'
    | '/onboard'
    | '/$tenantId/ingredients/$ingredientId'
    | '/$tenantId/recipes/$recipeId'
    | '/$tenantId/settings/billing'
    | '/$tenantId/settings/labels'
    | '/$tenantId/settings/recipe-tags'
    | '/$tenantId/settings/suppliers'
    | '/$tenantId/settings/tax'
    | '/$tenantId/settings/team'
    | '/$tenantId/ingredients'
    | '/$tenantId/recipes'
    | '/$tenantId/settings'
    | '/admin/suppliers'
    | '/admin/suppliers/$supplierId/$ingredientId'
    | '/admin/suppliers/$supplierId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/update-password'
    | '/_authenticated/$tenantId'
    | '/_authenticated/admin'
    | '/_authenticated/invites'
    | '/_authenticated/'
    | '/_authenticated/$tenantId/settings'
    | '/_authenticated/admin/suppliers'
    | '/_authenticated/admin/organisations'
    | '/_authenticated/onboard/setup-suppliers'
    | '/_authenticated/$tenantId/'
    | '/_authenticated/admin/'
    | '/_authenticated/onboard/'
    | '/_authenticated/$tenantId/ingredients/$ingredientId'
    | '/_authenticated/$tenantId/recipes/$recipeId'
    | '/_authenticated/$tenantId/settings/billing'
    | '/_authenticated/$tenantId/settings/labels'
    | '/_authenticated/$tenantId/settings/recipe-tags'
    | '/_authenticated/$tenantId/settings/suppliers'
    | '/_authenticated/$tenantId/settings/tax'
    | '/_authenticated/$tenantId/settings/team'
    | '/_authenticated/$tenantId/ingredients/'
    | '/_authenticated/$tenantId/recipes/'
    | '/_authenticated/$tenantId/settings/'
    | '/_authenticated/admin/suppliers/'
    | '/_authenticated/admin/suppliers/$supplierId/$ingredientId'
    | '/_authenticated/admin/suppliers/$supplierId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  UpdatePasswordRoute: typeof UpdatePasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/update-password': {
      id: '/update-password'
      path: '/update-password'
      fullPath: '/update-password'
      preLoaderRoute: typeof UpdatePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/invites': {
      id: '/_authenticated/invites'
      path: '/invites'
      fullPath: '/invites'
      preLoaderRoute: typeof AuthenticatedInvitesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/$tenantId': {
      id: '/_authenticated/$tenantId'
      path: '/$tenantId'
      fullPath: '/$tenantId'
      preLoaderRoute: typeof AuthenticatedTenantIdRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/onboard/': {
      id: '/_authenticated/onboard/'
      path: '/onboard'
      fullPath: '/onboard'
      preLoaderRoute: typeof AuthenticatedOnboardIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/$tenantId/': {
      id: '/_authenticated/$tenantId/'
      path: '/'
      fullPath: '/$tenantId/'
      preLoaderRoute: typeof AuthenticatedTenantIdIndexRouteImport
      parentRoute: typeof AuthenticatedTenantIdRouteRoute
    }
    '/_authenticated/onboard/setup-suppliers': {
      id: '/_authenticated/onboard/setup-suppliers'
      path: '/onboard/setup-suppliers'
      fullPath: '/onboard/setup-suppliers'
      preLoaderRoute: typeof AuthenticatedOnboardSetupSuppliersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/organisations': {
      id: '/_authenticated/admin/organisations'
      path: '/organisations'
      fullPath: '/admin/organisations'
      preLoaderRoute: typeof AuthenticatedAdminOrganisationsRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/suppliers': {
      id: '/_authenticated/admin/suppliers'
      path: '/suppliers'
      fullPath: '/admin/suppliers'
      preLoaderRoute: typeof AuthenticatedAdminSuppliersRouteRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/$tenantId/settings': {
      id: '/_authenticated/$tenantId/settings'
      path: '/settings'
      fullPath: '/$tenantId/settings'
      preLoaderRoute: typeof AuthenticatedTenantIdSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedTenantIdRouteRoute
    }
    '/_authenticated/admin/suppliers/': {
      id: '/_authenticated/admin/suppliers/'
      path: '/'
      fullPath: '/admin/suppliers/'
      preLoaderRoute: typeof AuthenticatedAdminSuppliersIndexRouteImport
      parentRoute: typeof AuthenticatedAdminSuppliersRouteRoute
    }
    '/_authenticated/$tenantId/settings/': {
      id: '/_authenticated/$tenantId/settings/'
      path: '/'
      fullPath: '/$tenantId/settings/'
      preLoaderRoute: typeof AuthenticatedTenantIdSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedTenantIdSettingsRouteRoute
    }
    '/_authenticated/$tenantId/recipes/': {
      id: '/_authenticated/$tenantId/recipes/'
      path: '/recipes'
      fullPath: '/$tenantId/recipes'
      preLoaderRoute: typeof AuthenticatedTenantIdRecipesIndexRouteImport
      parentRoute: typeof AuthenticatedTenantIdRouteRoute
    }
    '/_authenticated/$tenantId/ingredients/': {
      id: '/_authenticated/$tenantId/ingredients/'
      path: '/ingredients'
      fullPath: '/$tenantId/ingredients'
      preLoaderRoute: typeof AuthenticatedTenantIdIngredientsIndexRouteImport
      parentRoute: typeof AuthenticatedTenantIdRouteRoute
    }
    '/_authenticated/$tenantId/settings/team': {
      id: '/_authenticated/$tenantId/settings/team'
      path: '/team'
      fullPath: '/$tenantId/settings/team'
      preLoaderRoute: typeof AuthenticatedTenantIdSettingsTeamRouteImport
      parentRoute: typeof AuthenticatedTenantIdSettingsRouteRoute
    }
    '/_authenticated/$tenantId/settings/tax': {
      id: '/_authenticated/$tenantId/settings/tax'
      path: '/tax'
      fullPath: '/$tenantId/settings/tax'
      preLoaderRoute: typeof AuthenticatedTenantIdSettingsTaxRouteImport
      parentRoute: typeof AuthenticatedTenantIdSettingsRouteRoute
    }
    '/_authenticated/$tenantId/settings/suppliers': {
      id: '/_authenticated/$tenantId/settings/suppliers'
      path: '/suppliers'
      fullPath: '/$tenantId/settings/suppliers'
      preLoaderRoute: typeof AuthenticatedTenantIdSettingsSuppliersRouteImport
      parentRoute: typeof AuthenticatedTenantIdSettingsRouteRoute
    }
    '/_authenticated/$tenantId/settings/recipe-tags': {
      id: '/_authenticated/$tenantId/settings/recipe-tags'
      path: '/recipe-tags'
      fullPath: '/$tenantId/settings/recipe-tags'
      preLoaderRoute: typeof AuthenticatedTenantIdSettingsRecipeTagsRouteImport
      parentRoute: typeof AuthenticatedTenantIdSettingsRouteRoute
    }
    '/_authenticated/$tenantId/settings/labels': {
      id: '/_authenticated/$tenantId/settings/labels'
      path: '/labels'
      fullPath: '/$tenantId/settings/labels'
      preLoaderRoute: typeof AuthenticatedTenantIdSettingsLabelsRouteImport
      parentRoute: typeof AuthenticatedTenantIdSettingsRouteRoute
    }
    '/_authenticated/$tenantId/settings/billing': {
      id: '/_authenticated/$tenantId/settings/billing'
      path: '/billing'
      fullPath: '/$tenantId/settings/billing'
      preLoaderRoute: typeof AuthenticatedTenantIdSettingsBillingRouteImport
      parentRoute: typeof AuthenticatedTenantIdSettingsRouteRoute
    }
    '/_authenticated/$tenantId/recipes/$recipeId': {
      id: '/_authenticated/$tenantId/recipes/$recipeId'
      path: '/recipes/$recipeId'
      fullPath: '/$tenantId/recipes/$recipeId'
      preLoaderRoute: typeof AuthenticatedTenantIdRecipesRecipeIdRouteImport
      parentRoute: typeof AuthenticatedTenantIdRouteRoute
    }
    '/_authenticated/$tenantId/ingredients/$ingredientId': {
      id: '/_authenticated/$tenantId/ingredients/$ingredientId'
      path: '/ingredients/$ingredientId'
      fullPath: '/$tenantId/ingredients/$ingredientId'
      preLoaderRoute: typeof AuthenticatedTenantIdIngredientsIngredientIdRouteImport
      parentRoute: typeof AuthenticatedTenantIdRouteRoute
    }
    '/_authenticated/admin/suppliers/$supplierId/': {
      id: '/_authenticated/admin/suppliers/$supplierId/'
      path: '/$supplierId'
      fullPath: '/admin/suppliers/$supplierId'
      preLoaderRoute: typeof AuthenticatedAdminSuppliersSupplierIdIndexRouteImport
      parentRoute: typeof AuthenticatedAdminSuppliersRouteRoute
    }
    '/_authenticated/admin/suppliers/$supplierId/$ingredientId': {
      id: '/_authenticated/admin/suppliers/$supplierId/$ingredientId'
      path: '/$supplierId/$ingredientId'
      fullPath: '/admin/suppliers/$supplierId/$ingredientId'
      preLoaderRoute: typeof AuthenticatedAdminSuppliersSupplierIdIngredientIdRouteImport
      parentRoute: typeof AuthenticatedAdminSuppliersRouteRoute
    }
  }
}

interface AuthenticatedTenantIdSettingsRouteRouteChildren {
  AuthenticatedTenantIdSettingsBillingRoute: typeof AuthenticatedTenantIdSettingsBillingRoute
  AuthenticatedTenantIdSettingsLabelsRoute: typeof AuthenticatedTenantIdSettingsLabelsRoute
  AuthenticatedTenantIdSettingsRecipeTagsRoute: typeof AuthenticatedTenantIdSettingsRecipeTagsRoute
  AuthenticatedTenantIdSettingsSuppliersRoute: typeof AuthenticatedTenantIdSettingsSuppliersRoute
  AuthenticatedTenantIdSettingsTaxRoute: typeof AuthenticatedTenantIdSettingsTaxRoute
  AuthenticatedTenantIdSettingsTeamRoute: typeof AuthenticatedTenantIdSettingsTeamRoute
  AuthenticatedTenantIdSettingsIndexRoute: typeof AuthenticatedTenantIdSettingsIndexRoute
}

const AuthenticatedTenantIdSettingsRouteRouteChildren: AuthenticatedTenantIdSettingsRouteRouteChildren =
  {
    AuthenticatedTenantIdSettingsBillingRoute:
      AuthenticatedTenantIdSettingsBillingRoute,
    AuthenticatedTenantIdSettingsLabelsRoute:
      AuthenticatedTenantIdSettingsLabelsRoute,
    AuthenticatedTenantIdSettingsRecipeTagsRoute:
      AuthenticatedTenantIdSettingsRecipeTagsRoute,
    AuthenticatedTenantIdSettingsSuppliersRoute:
      AuthenticatedTenantIdSettingsSuppliersRoute,
    AuthenticatedTenantIdSettingsTaxRoute:
      AuthenticatedTenantIdSettingsTaxRoute,
    AuthenticatedTenantIdSettingsTeamRoute:
      AuthenticatedTenantIdSettingsTeamRoute,
    AuthenticatedTenantIdSettingsIndexRoute:
      AuthenticatedTenantIdSettingsIndexRoute,
  }

const AuthenticatedTenantIdSettingsRouteRouteWithChildren =
  AuthenticatedTenantIdSettingsRouteRoute._addFileChildren(
    AuthenticatedTenantIdSettingsRouteRouteChildren,
  )

interface AuthenticatedTenantIdRouteRouteChildren {
  AuthenticatedTenantIdSettingsRouteRoute: typeof AuthenticatedTenantIdSettingsRouteRouteWithChildren
  AuthenticatedTenantIdIndexRoute: typeof AuthenticatedTenantIdIndexRoute
  AuthenticatedTenantIdIngredientsIngredientIdRoute: typeof AuthenticatedTenantIdIngredientsIngredientIdRoute
  AuthenticatedTenantIdRecipesRecipeIdRoute: typeof AuthenticatedTenantIdRecipesRecipeIdRoute
  AuthenticatedTenantIdIngredientsIndexRoute: typeof AuthenticatedTenantIdIngredientsIndexRoute
  AuthenticatedTenantIdRecipesIndexRoute: typeof AuthenticatedTenantIdRecipesIndexRoute
}

const AuthenticatedTenantIdRouteRouteChildren: AuthenticatedTenantIdRouteRouteChildren =
  {
    AuthenticatedTenantIdSettingsRouteRoute:
      AuthenticatedTenantIdSettingsRouteRouteWithChildren,
    AuthenticatedTenantIdIndexRoute: AuthenticatedTenantIdIndexRoute,
    AuthenticatedTenantIdIngredientsIngredientIdRoute:
      AuthenticatedTenantIdIngredientsIngredientIdRoute,
    AuthenticatedTenantIdRecipesRecipeIdRoute:
      AuthenticatedTenantIdRecipesRecipeIdRoute,
    AuthenticatedTenantIdIngredientsIndexRoute:
      AuthenticatedTenantIdIngredientsIndexRoute,
    AuthenticatedTenantIdRecipesIndexRoute:
      AuthenticatedTenantIdRecipesIndexRoute,
  }

const AuthenticatedTenantIdRouteRouteWithChildren =
  AuthenticatedTenantIdRouteRoute._addFileChildren(
    AuthenticatedTenantIdRouteRouteChildren,
  )

interface AuthenticatedAdminSuppliersRouteRouteChildren {
  AuthenticatedAdminSuppliersIndexRoute: typeof AuthenticatedAdminSuppliersIndexRoute
  AuthenticatedAdminSuppliersSupplierIdIngredientIdRoute: typeof AuthenticatedAdminSuppliersSupplierIdIngredientIdRoute
  AuthenticatedAdminSuppliersSupplierIdIndexRoute: typeof AuthenticatedAdminSuppliersSupplierIdIndexRoute
}

const AuthenticatedAdminSuppliersRouteRouteChildren: AuthenticatedAdminSuppliersRouteRouteChildren =
  {
    AuthenticatedAdminSuppliersIndexRoute:
      AuthenticatedAdminSuppliersIndexRoute,
    AuthenticatedAdminSuppliersSupplierIdIngredientIdRoute:
      AuthenticatedAdminSuppliersSupplierIdIngredientIdRoute,
    AuthenticatedAdminSuppliersSupplierIdIndexRoute:
      AuthenticatedAdminSuppliersSupplierIdIndexRoute,
  }

const AuthenticatedAdminSuppliersRouteRouteWithChildren =
  AuthenticatedAdminSuppliersRouteRoute._addFileChildren(
    AuthenticatedAdminSuppliersRouteRouteChildren,
  )

interface AuthenticatedAdminRouteRouteChildren {
  AuthenticatedAdminSuppliersRouteRoute: typeof AuthenticatedAdminSuppliersRouteRouteWithChildren
  AuthenticatedAdminOrganisationsRoute: typeof AuthenticatedAdminOrganisationsRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteRouteChildren: AuthenticatedAdminRouteRouteChildren =
  {
    AuthenticatedAdminSuppliersRouteRoute:
      AuthenticatedAdminSuppliersRouteRouteWithChildren,
    AuthenticatedAdminOrganisationsRoute: AuthenticatedAdminOrganisationsRoute,
    AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
  }

const AuthenticatedAdminRouteRouteWithChildren =
  AuthenticatedAdminRouteRoute._addFileChildren(
    AuthenticatedAdminRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedTenantIdRouteRoute: typeof AuthenticatedTenantIdRouteRouteWithChildren
  AuthenticatedAdminRouteRoute: typeof AuthenticatedAdminRouteRouteWithChildren
  AuthenticatedInvitesRoute: typeof AuthenticatedInvitesRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedOnboardSetupSuppliersRoute: typeof AuthenticatedOnboardSetupSuppliersRoute
  AuthenticatedOnboardIndexRoute: typeof AuthenticatedOnboardIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedTenantIdRouteRoute: AuthenticatedTenantIdRouteRouteWithChildren,
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren,
  AuthenticatedInvitesRoute: AuthenticatedInvitesRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedOnboardSetupSuppliersRoute:
    AuthenticatedOnboardSetupSuppliersRoute,
  AuthenticatedOnboardIndexRoute: AuthenticatedOnboardIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  UpdatePasswordRoute: UpdatePasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
